// 运营
export default {
  path: '/operate',
  title: '运营',
  icon: 'flask',
  children: (pre => [
    { path: `${pre}/feedback`, title: '意见反馈', icon: 'iconyijianfankui_default', auth_token: 'xg:operationManagement:feedbackList' }
    // { path: `${pre}/bind`, title: '绑定申请', icon: 'iconbangdingshenqing', auth_token: 'xg:member:list1' },
    // { path: `${pre}/bindLog`, title: '绑定日志', icon: 'iconrizhi', auth_token: 'xg:member:list2' }
    // { path: `${pre}/message`, title: '消息管理', icon: 'home' },
    // { path: `${pre}/comment`, title: '评论管理', icon: 'home' }
  ])('/operate')
}
